import {
	REPORT_COMPLAINT_CAR_MODEL_FETCH,
	REPORT_COMPLAINT_CAR_MODEL_FETCH_SUCCESS,
	REPORT_COMPLAINT_CAR_MODEL_FETCH_RESET,
	REPORT_COMPLAINT_CATEGORIES_FETCH,
	REPORT_COMPLAINT_CATEGORIES_FETCH_SUCCESS,
	REPORT_COMPLAINT_CATEGORIES_FETCH_RESET,
	REPORT_SURVEY_FETCH,
	REPORT_SURVEY_FETCH_SUCCESS,
	REPORT_SURVEY_FETCH_RESET,
	REPORT_TICKET_FETCH,
	REPORT_TICKET_FETCH_SUCCESS,
	REPORT_TICKET_FETCH_RESET,
	REPORT_TICKET_3MONTHS_FETCH,
	REPORT_TICKET_3MONTHS_FETCH_SUCCESS,
	REPORT_TICKET_3MONTHS_FETCH_RESET,
	REPORT_TICKET_6MONTHS_FETCH,
	REPORT_TICKET_6MONTHS_FETCH_SUCCESS,
	REPORT_TICKET_6MONTHS_FETCH_RESET,
	REPORT_TICKET_YTD_FETCH,
	REPORT_TICKET_YTD_FETCH_SUCCESS,
	REPORT_TICKET_YTD_FETCH_RESET,
	REPORT_TICKET_SHOWROOM_STATUSES_FETCH,
	REPORT_TICKET_SHOWROOM_STATUSES_FETCH_SUCCESS,
	REPORT_TICKET_SHOWROOM_STATUSES_FETCH_RESET,
	REPORT_TICKET_SERVICE_STATUSES_FETCH,
	REPORT_TICKET_SERVICE_STATUSES_FETCH_SUCCESS,
	REPORT_TICKET_SERVICE_STATUSES_FETCH_RESET,
	REPORT_TICKETS_SHOWROOM_FETCH,
	REPORT_TICKETS_SHOWROOM_FETCH_SUCCESS,
	REPORT_TICKETS_SHOWROOM_FETCH_RESET,
	REPORT_TICKETS_SERVICE_FETCH,
	REPORT_TICKETS_SERVICE_FETCH_SUCCESS,
	REPORT_TICKETS_SERVICE_FETCH_RESET,
	REPORT_TICKETS_SHOWROOM_FORM_UPDATE,
	REPORT_TICKETS_SERVICE_FORM_UPDATE,
	REPORT_TICKET_HOTSHEET_SHOWROOM_STATUSES_FETCH,
	REPORT_TICKET_HOTSHEET_SHOWROOM_STATUSES_FETCH_SUCCESS,
	REPORT_TICKET_HOTSHEET_SHOWROOM_STATUSES_FETCH_RESET,
	REPORT_TICKET_HOTSHEET_SERVICE_STATUSES_FETCH,
	REPORT_TICKET_HOTSHEET_SERVICE_STATUSES_FETCH_SUCCESS,
	REPORT_TICKET_HOTSHEET_SERVICE_STATUSES_FETCH_RESET,
	REPORT_TICKETS_HOTSHEET_SHOWROOM_FETCH,
	REPORT_TICKETS_HOTSHEET_SHOWROOM_FETCH_SUCCESS,
	REPORT_TICKETS_HOTSHEET_SHOWROOM_FETCH_RESET,
	REPORT_TICKETS_HOTSHEET_SERVICE_FETCH,
	REPORT_TICKETS_HOTSHEET_SERVICE_FETCH_SUCCESS,
	REPORT_TICKETS_HOTSHEET_SERVICE_FETCH_RESET,
	REPORT_TICKETS_HOTSHEET_SHOWROOM_FORM_UPDATE,
	REPORT_TICKETS_HOTSHEET_SERVICE_FORM_UPDATE,
	REPORT_TICKET_CALLCENTER_SHOWROOM_STATUSES_FETCH,
	REPORT_TICKET_CALLCENTER_SHOWROOM_STATUSES_FETCH_SUCCESS,
	REPORT_TICKET_CALLCENTER_SHOWROOM_STATUSES_FETCH_RESET,
	REPORT_TICKET_CALLCENTER_SERVICE_STATUSES_FETCH,
	REPORT_TICKET_CALLCENTER_SERVICE_STATUSES_FETCH_SUCCESS,
	REPORT_TICKET_CALLCENTER_SERVICE_STATUSES_FETCH_RESET,
	REPORT_TICKETS_CALLCENTER_SHOWROOM_FETCH,
	REPORT_TICKETS_CALLCENTER_SHOWROOM_FETCH_SUCCESS,
	REPORT_TICKETS_CALLCENTER_SHOWROOM_FETCH_RESET,
	REPORT_TICKETS_CALLCENTER_SERVICE_FETCH,
	REPORT_TICKETS_CALLCENTER_SERVICE_FETCH_SUCCESS,
	REPORT_TICKETS_CALLCENTER_SERVICE_FETCH_RESET,
	REPORT_TICKETS_CALLCENTER_SHOWROOM_FORM_UPDATE,
	REPORT_TICKETS_CALLCENTER_SERVICE_FORM_UPDATE,
	REPORT_TICKET_KPI_FETCH,
	REPORT_TICKET_KPI_FETCH_SUCCESS,
	REPORT_TICKET_KPI_FETCH_RESET,
	REPORT_TICKET_KPI_3MONTHS_FETCH,
	REPORT_TICKET_KPI_3MONTHS_FETCH_SUCCESS,
	REPORT_TICKET_KPI_3MONTHS_FETCH_RESET,
	REPORT_TICKET_KPI_6MONTHS_FETCH,
	REPORT_TICKET_KPI_6MONTHS_FETCH_SUCCESS,
	REPORT_TICKET_KPI_6MONTHS_FETCH_RESET,
	REPORT_TICKET_KPI_YTD_FETCH,
	REPORT_TICKET_KPI_YTD_FETCH_SUCCESS,
	REPORT_TICKET_KPI_YTD_FETCH_RESET,
	REPORT_TICKET_KPI_SURVEY_FETCH,
	REPORT_TICKET_KPI_SURVEY_FETCH_SUCCESS,
	REPORT_TICKET_KPI_SURVEY_FETCH_RESET,
	REPORT_CASE_CLOSED_EXPORT_EXCEL,
	REPORT_CASE_CLOSED_V1_EXPORT_EXCEL,
	REPORT_RESPONSE_RATE_SHOWROOM_FETCH,
	REPORT_RESPONSE_RATE_SHOWROOM_FETCH_SUCCESS,
	REPORT_RESPONSE_RATE_SHOWROOM_FETCH_RESET,
	REPORT_RESPONSE_RATE_SERVICE_FETCH,
	REPORT_RESPONSE_RATE_SERVICE_FETCH_SUCCESS,
	REPORT_RESPONSE_RATE_SERVICE_FETCH_RESET,
	REPORT_RESPONSE_RATE_EXPORT_EXCEL,
	REPORT_NOTIFY_SHOWROOM_FETCH,
	REPORT_NOTIFY_SHOWROOM_FETCH_RESET,
	REPORT_NOTIFY_SHOWROOM_FETCH_SUCCESS,
	REPORT_NOTIFY_SERVICE_FETCH,
	REPORT_NOTIFY_SERVICE_FETCH_RESET,
	REPORT_NOTIFY_SERVICE_FETCH_SUCCESS,
	REPORT_NOTIFY_EXPORT_EXCEL,
	REPORT_PDCA_EXPORT_EXCEL,
	REPORT_TICKET_KPI_EXPORT_EXCEL,
	REPORT_QVOC_KPI_EXPORT_EXCEL,
	REPORT_QVOC_KPI_FETCH,
	REPORT_QVOC_KPI_FETCH_SUCCESS,
	REPORT_QVOC_KPI_FETCH_RESET,
	REPORT_TICKET_KPI_ALL_FETCH,
	REPORT_TICKET_KPI_ALL_FETCH_SUCCESS,
	REPORT_TICKET_KPI_ALL_FETCH_RESET
} from "./types";

export const reportComplaintCarModelFetch = payload => {
	return {
		type: REPORT_COMPLAINT_CAR_MODEL_FETCH,
		payload: payload
	};
};

export const reportComplaintCarModelFetchSuccess = payload => {
	return {
		type: REPORT_COMPLAINT_CAR_MODEL_FETCH_SUCCESS,
		payload: payload
	};
};

export const reportComplaintCarModelFetchReset = () => {
	return {
		type: REPORT_COMPLAINT_CAR_MODEL_FETCH_RESET
	};
};

export const reportComplaintCategoriesFetch = payload => {
	return {
		type: REPORT_COMPLAINT_CATEGORIES_FETCH,
		payload: payload
	};
};

export const reportComplaintCategoriesFetchSuccess = payload => {
	return {
		type: REPORT_COMPLAINT_CATEGORIES_FETCH_SUCCESS,
		payload: payload
	};
};

export const reportComplaintCategoriesFetchReset = () => {
	return {
		type: REPORT_COMPLAINT_CATEGORIES_FETCH_RESET
	};
};

export const reportSurveyFetch = payload => {
	return {
		type: REPORT_SURVEY_FETCH,
		payload: payload
	};
};

export const reportSurveyFetchSuccess = payload => {
	return {
		type: REPORT_SURVEY_FETCH_SUCCESS,
		payload: payload
	};
};

export const reportSurveyFetchReset = () => {
	return {
		type: REPORT_SURVEY_FETCH_RESET
	};
};

export const reportTicketFetch = payload => {
	return {
		type: REPORT_TICKET_FETCH,
		payload: payload
	};
};

export const reportTicketFetchSuccess = payload => {
	return {
		type: REPORT_TICKET_FETCH_SUCCESS,
		payload: payload
	};
};

export const reportTicketFetchReset = () => {
	return {
		type: REPORT_TICKET_FETCH_RESET
	};
};

export const reportTicket3MonthsFetch = payload => {
	return {
		type: REPORT_TICKET_3MONTHS_FETCH,
		payload: payload
	};
};

export const reportTicket3MonthsFetchSuccess = payload => {
	return {
		type: REPORT_TICKET_3MONTHS_FETCH_SUCCESS,
		payload: payload
	};
};

export const reportTicket3MonthsFetchReset = () => {
	return {
		type: REPORT_TICKET_3MONTHS_FETCH_RESET
	};
};

export const reportTicket6MonthsFetch = payload => {
	return {
		type: REPORT_TICKET_6MONTHS_FETCH,
		payload: payload
	};
};

export const reportTicket6MonthsFetchSuccess = payload => {
	return {
		type: REPORT_TICKET_6MONTHS_FETCH_SUCCESS,
		payload: payload
	};
};

export const reportTicket6MonthsFetchReset = () => {
	return {
		type: REPORT_TICKET_6MONTHS_FETCH_RESET
	};
};

export const reportTicketYtdFetch = payload => {
	return {
		type: REPORT_TICKET_YTD_FETCH,
		payload: payload
	};
};

export const reportTicketYtdFetchSuccess = payload => {
	return {
		type: REPORT_TICKET_YTD_FETCH_SUCCESS,
		payload: payload
	};
};

export const reportTicketYtdFetchReset = () => {
	return {
		type: REPORT_TICKET_YTD_FETCH_RESET
	};
};

export const reportTicketShowroomStatusFetch = payload => {
	return {
		type: REPORT_TICKET_SHOWROOM_STATUSES_FETCH,
		payload: payload
	};
};

export const reportTicketShowroomStatusFetchSuccess = payload => {
	return {
		type: REPORT_TICKET_SHOWROOM_STATUSES_FETCH_SUCCESS,
		payload: payload
	};
};

export const reportTicketShowroomStatusFetchReset = () => {
	return {
		type: REPORT_TICKET_SHOWROOM_STATUSES_FETCH_RESET
	};
};

export const reportTicketServiceStatusFetch = payload => {
	return {
		type: REPORT_TICKET_SERVICE_STATUSES_FETCH,
		payload: payload
	};
};

export const reportTicketServiceStatusFetchSuccess = payload => {
	return {
		type: REPORT_TICKET_SERVICE_STATUSES_FETCH_SUCCESS,
		payload: payload
	};
};

export const reportTicketServiceStatusFetchReset = () => {
	return {
		type: REPORT_TICKET_SERVICE_STATUSES_FETCH_RESET
	};
};

export const reportTicketsShowroomFetch = payload => {
	return {
		type: REPORT_TICKETS_SHOWROOM_FETCH,
		payload: payload
	};
};

export const reportTicketsShowroomFetchSuccess = payload => {
	return {
		type: REPORT_TICKETS_SHOWROOM_FETCH_SUCCESS,
		payload: payload
	};
};

export const reportTicketsShowroomFetchReset = () => {
	return {
		type: REPORT_TICKETS_SHOWROOM_FETCH_RESET
	};
};

export const reportTicketsServiceFetch = payload => {
	return {
		type: REPORT_TICKETS_SERVICE_FETCH,
		payload: payload
	};
};

export const reportTicketsServiceFetchSuccess = payload => {
	return {
		type: REPORT_TICKETS_SERVICE_FETCH_SUCCESS,
		payload: payload
	};
};

export const reportTicketsServiceFetchReset = () => {
	return {
		type: REPORT_TICKETS_SERVICE_FETCH_RESET
	};
};

export const reportTicketsShowroomFormUpdate = payload => {
	return {
		type: REPORT_TICKETS_SHOWROOM_FORM_UPDATE,
		payload: payload
	};
};

export const reportTicketsServiceFormUpdate = payload => {
	return {
		type: REPORT_TICKETS_SERVICE_FORM_UPDATE,
		payload: payload
	};
};

export const reportTicketHotSheetShowroomStatusFetch = payload => {
	return {
		type: REPORT_TICKET_HOTSHEET_SHOWROOM_STATUSES_FETCH,
		payload: payload
	};
};

export const reportTicketHotSheetShowroomStatusFetchSuccess = payload => {
	return {
		type: REPORT_TICKET_HOTSHEET_SHOWROOM_STATUSES_FETCH_SUCCESS,
		payload: payload
	};
};

export const reportTicketHotSheetShowroomStatusFetchReset = () => {
	return {
		type: REPORT_TICKET_HOTSHEET_SHOWROOM_STATUSES_FETCH_RESET
	};
};

export const reportTicketHotSheetServiceStatusFetch = payload => {
	return {
		type: REPORT_TICKET_HOTSHEET_SERVICE_STATUSES_FETCH,
		payload: payload
	};
};

export const reportTicketHotSheetServiceStatusFetchSuccess = payload => {
	return {
		type: REPORT_TICKET_HOTSHEET_SERVICE_STATUSES_FETCH_SUCCESS,
		payload: payload
	};
};

export const reportTicketHotSheetServiceStatusFetchReset = () => {
	return {
		type: REPORT_TICKET_HOTSHEET_SERVICE_STATUSES_FETCH_RESET
	};
};

export const reportTicketsHotSheetShowroomFetch = payload => {
	return {
		type: REPORT_TICKETS_HOTSHEET_SHOWROOM_FETCH,
		payload: payload
	};
};

export const reportTicketsHotSheetShowroomFetchSuccess = payload => {
	return {
		type: REPORT_TICKETS_HOTSHEET_SHOWROOM_FETCH_SUCCESS,
		payload: payload
	};
};

export const reportTicketsHotSheetShowroomFetchReset = () => {
	return {
		type: REPORT_TICKETS_HOTSHEET_SHOWROOM_FETCH_RESET
	};
};

export const reportTicketsHotSheetServiceFetch = payload => {
	return {
		type: REPORT_TICKETS_HOTSHEET_SERVICE_FETCH,
		payload: payload
	};
};

export const reportTicketsHotSheetServiceFetchSuccess = payload => {
	return {
		type: REPORT_TICKETS_HOTSHEET_SERVICE_FETCH_SUCCESS,
		payload: payload
	};
};

export const reportTicketsHotSheetServiceFetchReset = () => {
	return {
		type: REPORT_TICKETS_HOTSHEET_SERVICE_FETCH_RESET
	};
};

export const reportTicketsHotSheetShowroomFormUpdate = payload => {
	return {
		type: REPORT_TICKETS_HOTSHEET_SHOWROOM_FORM_UPDATE,
		payload: payload
	};
};

export const reportTicketsHotSheetServiceFormUpdate = payload => {
	return {
		type: REPORT_TICKETS_HOTSHEET_SERVICE_FORM_UPDATE,
		payload: payload
	};
};

export const reportTicketCallCenterShowroomStatusFetch = payload => {
	return {
		type: REPORT_TICKET_CALLCENTER_SHOWROOM_STATUSES_FETCH,
		payload: payload
	};
};

export const reportTicketCallCenterShowroomStatusFetchSuccess = payload => {
	return {
		type: REPORT_TICKET_CALLCENTER_SHOWROOM_STATUSES_FETCH_SUCCESS,
		payload: payload
	};
};

export const reportTicketCallCenterShowroomStatusFetchReset = () => {
	return {
		type: REPORT_TICKET_CALLCENTER_SHOWROOM_STATUSES_FETCH_RESET
	};
};

export const reportTicketCallCenterServiceStatusFetch = payload => {
	return {
		type: REPORT_TICKET_CALLCENTER_SERVICE_STATUSES_FETCH,
		payload: payload
	};
};

export const reportTicketCallCenterServiceStatusFetchSuccess = payload => {
	return {
		type: REPORT_TICKET_CALLCENTER_SERVICE_STATUSES_FETCH_SUCCESS,
		payload: payload
	};
};

export const reportTicketCallCenterServiceStatusFetchReset = () => {
	return {
		type: REPORT_TICKET_CALLCENTER_SERVICE_STATUSES_FETCH_RESET
	};
};

export const reportTicketsCallCenterShowroomFetch = payload => {
	return {
		type: REPORT_TICKETS_CALLCENTER_SHOWROOM_FETCH,
		payload: payload
	};
};

export const reportTicketsCallCenterShowroomFetchSuccess = payload => {
	return {
		type: REPORT_TICKETS_CALLCENTER_SHOWROOM_FETCH_SUCCESS,
		payload: payload
	};
};

export const reportTicketsCallCenterShowroomFetchReset = () => {
	return {
		type: REPORT_TICKETS_CALLCENTER_SHOWROOM_FETCH_RESET
	};
};

export const reportTicketsCallCenterServiceFetch = payload => {
	return {
		type: REPORT_TICKETS_CALLCENTER_SERVICE_FETCH,
		payload: payload
	};
};

export const reportTicketsCallCenterServiceFetchSuccess = payload => {
	return {
		type: REPORT_TICKETS_CALLCENTER_SERVICE_FETCH_SUCCESS,
		payload: payload
	};
};

export const reportTicketsCallCenterServiceFetchReset = () => {
	return {
		type: REPORT_TICKETS_CALLCENTER_SERVICE_FETCH_RESET
	};
};

export const reportTicketsCallCenterShowroomFormUpdate = payload => {
	return {
		type: REPORT_TICKETS_CALLCENTER_SHOWROOM_FORM_UPDATE,
		payload: payload
	};
};

export const reportTicketsCallCenterServiceFormUpdate = payload => {
	return {
		type: REPORT_TICKETS_CALLCENTER_SERVICE_FORM_UPDATE,
		payload: payload
	};
};

export const reportTicketKpiFetch = payload => {
	return {
		type: REPORT_TICKET_KPI_FETCH,
		payload: payload
	};
};

export const reportTicketKpiFetchSuccess = payload => {
	return {
		type: REPORT_TICKET_KPI_FETCH_SUCCESS,
		payload: payload
	};
};

export const reportTicketKpiFetchReset = () => {
	return {
		type: REPORT_TICKET_KPI_FETCH_RESET
	};
};

export const reportTicketKpi3MonthsFetch = payload => {
	return {
		type: REPORT_TICKET_KPI_3MONTHS_FETCH,
		payload: payload
	};
};

export const reportTicketKpi3MonthsFetchSuccess = payload => {
	return {
		type: REPORT_TICKET_KPI_3MONTHS_FETCH_SUCCESS,
		payload: payload
	};
};

export const reportTicketKpi3MonthsFetchReset = () => {
	return {
		type: REPORT_TICKET_KPI_3MONTHS_FETCH_RESET
	};
};

export const reportTicketKpi6MonthsFetch = payload => {
	return {
		type: REPORT_TICKET_KPI_6MONTHS_FETCH,
		payload: payload
	};
};

export const reportTicketKpi6MonthsFetchSuccess = payload => {
	return {
		type: REPORT_TICKET_KPI_6MONTHS_FETCH_SUCCESS,
		payload: payload
	};
};

export const reportTicketKpi6MonthsFetchReset = () => {
	return {
		type: REPORT_TICKET_KPI_6MONTHS_FETCH_RESET
	};
};

export const reportTicketKpiYtdFetch = payload => {
	return {
		type: REPORT_TICKET_KPI_YTD_FETCH,
		payload: payload
	};
};

export const reportTicketKpiYtdFetchSuccess = payload => {
	return {
		type: REPORT_TICKET_KPI_YTD_FETCH_SUCCESS,
		payload: payload
	};
};

export const reportTicketKpiYtdFetchReset = () => {
	return {
		type: REPORT_TICKET_KPI_YTD_FETCH_RESET
	};
};

export const reportTicketKpiSurveyFetch = payload => {
	return {
		type: REPORT_TICKET_KPI_SURVEY_FETCH,
		payload: payload
	};
};

export const reportTicketKpiSurveyFetchSuccess = payload => {
	return {
		type: REPORT_TICKET_KPI_SURVEY_FETCH_SUCCESS,
		payload: payload
	};
};

export const reportTicketKpiSurveyFetchReset = () => {
	return {
		type: REPORT_TICKET_KPI_SURVEY_FETCH_RESET
	};
};

export const reportCaseClosedExportExcel = payload => {
	return {
		type: REPORT_CASE_CLOSED_EXPORT_EXCEL,
		payload: payload
	}
}

export const reportCaseClosedV1ExportExcel = payload => {
	return {
		type: REPORT_CASE_CLOSED_V1_EXPORT_EXCEL,
		payload: payload
	}
}

export const reportResponseRateShowroomFetch = payload => {
	return {
		type: REPORT_RESPONSE_RATE_SHOWROOM_FETCH,
		payload: payload
	}
}

export const reportResponseRateShowroomFetchReset = () => {
	return {
		type: REPORT_RESPONSE_RATE_SHOWROOM_FETCH_RESET
	}
}

export const reportResponseRateShowroomFetchSuccess = payload => {
	return {
		type: REPORT_RESPONSE_RATE_SHOWROOM_FETCH_SUCCESS,
		payload: payload
	}
}

export const reportResponseRateServiceFetch = payload => {
	return {
		type: REPORT_RESPONSE_RATE_SERVICE_FETCH,
		payload: payload
	}
}

export const reportResponseRateServiceFetchReset = () => {
	return {
		type: REPORT_RESPONSE_RATE_SERVICE_FETCH_RESET
	}
}

export const reportResponseRateServiceFetchSuccess = payload => {
	return {
		type: REPORT_RESPONSE_RATE_SERVICE_FETCH_SUCCESS,
		payload: payload
	}
}

export const reportResponseRateExportExcel = payload => {
	return {
		type: REPORT_RESPONSE_RATE_EXPORT_EXCEL,
		payload: payload
	}
}

export const reportNotifyShowroomFetch = payload => {
	return {
		type: REPORT_NOTIFY_SHOWROOM_FETCH,
		payload: payload
	}
}

export const reportNotifyShowroomFetchReset = () => {
	return {
		type: REPORT_NOTIFY_SHOWROOM_FETCH_RESET
	}
}

export const reportNotifyShowroomFetchSuccess = payload => {
	return {
		type: REPORT_NOTIFY_SHOWROOM_FETCH_SUCCESS,
		payload: payload
	}
}

export const reportNotifyServiceFetch = payload => {
	return {
		type: REPORT_NOTIFY_SERVICE_FETCH,
		payload: payload
	}
}

export const reportNotifyServiceFetchReset = () => {
	return {
		type: REPORT_NOTIFY_SERVICE_FETCH_RESET
	}
}

export const reportNotifyServiceFetchSuccess = payload => {
	return {
		type: REPORT_NOTIFY_SERVICE_FETCH_SUCCESS,
		payload: payload
	}
}

export const reportNotifyExportExcel = payload => {
	return {
		type: REPORT_NOTIFY_EXPORT_EXCEL,
		payload: payload
	}
}

export const reportPdcaExportExcel = payload => {
	return {
		type: REPORT_PDCA_EXPORT_EXCEL,
		payload: payload
	}
}

export const reportTicketKpiExportExcel = payload => {
	return {
		type: REPORT_TICKET_KPI_EXPORT_EXCEL,
		payload: payload
	}
}

export const reportQvocKpiExportExcel = payload => {
	return {
		type: REPORT_QVOC_KPI_EXPORT_EXCEL,
		payload: payload
	}
}

export const reportQvocKpiFetch = payload => {
	return {
		type: REPORT_QVOC_KPI_FETCH,
		payload: payload
	};
};

export const reportQvocKpiFetchSuccess = payload => {
	return {
		type: REPORT_QVOC_KPI_FETCH_SUCCESS,
		payload: payload
	};
};

export const reportQvocKpiFetchReset = () => {
	return {
		type: REPORT_QVOC_KPI_FETCH_RESET
	};
};

export const reportTicketKpiAllFetch = payload => {
	return {
		type: REPORT_TICKET_KPI_ALL_FETCH,
		payload: payload
	};
};

export const reportTicketKpiAllFetchSuccess = payload => {
	return {
		type: REPORT_TICKET_KPI_ALL_FETCH_SUCCESS,
		payload: payload
	};
};

export const reportTicketKpiAllFetchReset = () => {
	return {
		type: REPORT_TICKET_KPI_ALL_FETCH_RESET
	};
};